import {map} from 'lodash';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {CopyText, Table, TableBody, TableRow, TableCell, Icon} from 'components';
import {TRANSLATION_KEYS} from 'locale';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.APPOINTMENTS.TABLE;

import {AppointmentsRendererProps} from '../types';

type Props = AppointmentsRendererProps;

export const AppointmentsTable: React.FC<Props> = ({
    loading, appointments, renderAssignmentInfo, renderCreateInfo, renderScheduledDates, renderParticipants, renderActions,
    getSourceName, onOpenConnectInfoModal
}: Props) => {
    const {t} = useTranslation();

    const headers = useMemo(() => [
        {children: t(T_KEYS.COLUMNS.ID), className: 'tw-w-9'},
        {children: t(T_KEYS.COLUMNS.NAME)},
        {children: t(T_KEYS.COLUMNS.ASSIGNMENT)},
        {children: t(T_KEYS.COLUMNS.SCHEDULE)},
        {children: t(T_KEYS.COLUMNS.PARTICIPANTS)},
        {children: t(T_KEYS.COLUMNS.CONNECT), className: 'tw-w-24'},
        {children: t(T_KEYS.COLUMNS.CREATED)},
        {children: t(T_KEYS.COLUMNS.ACTIONS), className: 'tw-w-24'},
    ], [t]);

    return (
        <Table headers={headers} loading={loading} noData={!appointments.length} columnsCount={7} className='tw-text-default'>
            <TableBody>
                {map(appointments, ({session, links}) => (
                    <TableRow key={session.id}>
                        <TableCell><CopyText iconColor='default-dimmed' text={session.id} iconOnly /></TableCell>
                        <TableCell>{session.name}</TableCell>
                        <TableCell>{renderAssignmentInfo(session.assignment)}</TableCell>
                        <TableCell>{renderScheduledDates(session.schedule)}</TableCell>
                        <TableCell>{renderParticipants(session, 'tw-mb-1 last:tw-mb-0')}</TableCell>
                        <TableCell>
                            <Icon
                                name='info'
                                color='default-dimmed'
                                button
                                onClick={() => onOpenConnectInfoModal({links, session})}
                            />
                        </TableCell>
                        <TableCell>{renderCreateInfo(session.createdAt, getSourceName(session))}</TableCell>
                        <TableCell>{renderActions(session)}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};